import { render, staticRenderFns } from "./modalEvent.vue?vue&type=template&id=6a22ea7e&scoped=true"
import script from "./modalEvent.vue?vue&type=script&lang=js"
export * from "./modalEvent.vue?vue&type=script&lang=js"
import style0 from "./modalEvent.vue?vue&type=style&index=0&id=6a22ea7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22ea7e",
  null
  
)

export default component.exports